<template>
  <v-layout row wrap>
    <v-flex class="pt-0 pb-3 px-3">
      <v-card class="elevation-0">
      
        <v-container fluid grid-list-md>
			<div>
				<v-btn color="success"
					@click="btn_onclick"
				>{{ username }}</v-btn>
			</div>
			<iframe
				src="http://192.168.22.246:4001/"
				frameborder="0"
				width="100%"
				height="600px"
			></iframe>
			<iframe
				:src="res"
				width="100%"
				height="600px"
          ></iframe>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import auth from "../../functions/auth";
import common from "../../functions/general";

export default {
  name: "Temp",
  // components: {
  //   Breadcrumbs: Breadcrumbs
  // },
  data: () => ({
    username: "",
		res: ""
  }),
  mounted: async function() {
    // this.initial();
    this.username = auth.getUsername();
    // var pageID = common.App.get_pageID();
    // this.cards = common.App.getAppMenu(pageID);
  },
  methods: {
		async btn_onclick(){
			let api = "report_generator/";
			let req_data =  {
				"data": [{
					"username": this.username,
				}]
			}
						
			let result = await common.wBackEndComm.PostData(api, req_data);

			if (result.data.Status == 1) {
				
				this.res = "data:application/pdf;base64,"+result.data.Body;
			} else {
				common.wMsgBox.Error(result.data.Description);
			}
			// let msgRes = await common.wBackEndComm.PostData(api);
			// this.res = msgRes.data;

			// const response = await fetch("http://127.0.0.1:8000/api_v1/"+api);
			// const blob = await response.blob();

			// this.res = URL.createObjectURL(blob);

		}
	}
};
</script>

<style>
</style>
